import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Oportunidad/Cartera',
  alias: [],
  documento: 'crm',
  filas: ['134'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/OportunidadController.cs:114',
} satisfies RutaProd;
